import { render, staticRenderFns } from "./AddMerchant.vue?vue&type=template&id=0262bdf4&scoped=true"
import script from "./AddMerchant.vue?vue&type=script&lang=js"
export * from "./AddMerchant.vue?vue&type=script&lang=js"
import style0 from "./AddMerchant.vue?vue&type=style&index=0&id=0262bdf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0262bdf4",
  null
  
)

export default component.exports